import { Header16, Header24, Header32, Header40, Paragraph16, SubHeader16 } from '../styles/typography'
import { SimpleLink } from '../components/atoms/link'
import styled from '@emotion/styled'
import { Footer } from '../components/atoms/footer'
import { Testimonials } from '../sections/Testimonials'
import { NavBar } from '../components/atoms/header'
import { HeroBackground, HeroContent, HeroMainHeader, ImageWrapper } from '../components/atoms/pageHero'
import heroImage from '../assets/images/projects/project3.jpg'
import { Contact } from '../sections/Contact'
import whiteLine from '../assets/images/vertical-line.png'
import profileImage from '../assets/images/about-portrait.png'
import { Background, MainContainer, ProfileContainer, ProfileImageWrapper, TextContainer } from '../components/about'
import { useParams } from 'react-router-dom'
import { projects } from '../projects'
import { BlueButton } from '../components/atoms/button'
import { useEffect } from 'react'

export const CustomList = styled.ul`
    list-style: none;
    padding-left: 0;
    margin-top: -32px;
    margin-bottom: unset;
`

export const CustomListItem = styled.li`
    position: relative;
    padding-left: 24px;

    &::before {
        content: '–'; /* could be "-" or "✓" or any unicode */
        position: absolute;
        left: 0;
        color: ${(props) => props.theme.primaryColor.blue[3]};
        font-weight: bold;
    }
`

export function ProjectPage() {
    const { projectId } = useParams()
    const project = projects.find((p) => p.id === projectId)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (!project) {
        return <h1>Project not found</h1>
    }

    return (
        <div>
            <NavBar />
            <HeroBackground>
                <HeroMainHeader>
                    <HeroContent>
                        <img src={whiteLine} style={{ height: '40px' }} />
                        <Header40 style={{ color: '#ffffff' }}>{project.title}</Header40>
                    </HeroContent>
                </HeroMainHeader>
                <ImageWrapper src={project.cover} />
            </HeroBackground>

            <Background>
                <MainContainer>
                    <ProfileContainer>
                        <ProfileImageWrapper src={project.img} />
                        <TextContainer style={{}}>
                            <h1 style={{ color: '#324C77' }}>{project.intro}</h1>
                            <h3 style={{ marginTop: '24px' }}>{project.details}</h3>
                            <CustomList>
                                {project.points.map((point, i) => (
                                    <CustomListItem key={i}>
                                        <h3>{point}</h3>
                                    </CustomListItem>
                                ))}
                            </CustomList>
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                                <SimpleLink to='/services'>
                                    <BlueButton style={{ width: '220px' }}>
                                        <SubHeader16>Back To Services</SubHeader16>
                                    </BlueButton>
                                </SimpleLink>
                            </div>
                        </TextContainer>
                    </ProfileContainer>
                </MainContainer>
            </Background>

            <Testimonials />
            <Contact />
            <Footer />
        </div>
    )
}
